<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Importazione definizioni</h1>
      </div>
      <p class="editor-lead">Importa i file Excel delle definizioni artistiche per ciascuna tabella.</p>
    </header>

    <section class="editor-panel">
      <h2>Definizioni artistiche</h2>

      @if (dataSource$ | async; as rows) {
        @if (rows.length === 0) {
          <p class="editor-hint">Nessuna definizione in elenco.</p>
        } @else {
          <div class="definition-list">
            @for (element of rows; track element.id) {
              <div class="definition-row">
                <div class="definition-identity">
                  <span class="definition-name">{{ element.name || '—' }}</span>
                  <span class="definition-meta">
                    <span>ID {{ element.id }}</span>
                    @if (element.code) {
                      <span>· Codice {{ element.code }}</span>
                    }
                  </span>
                  @if (element.filename) {
                    <span class="definition-file">
                      {{ element.filename }}
                      @if (element.updated_at) {
                        <span>· {{ element.updated_at }}</span>
                      }
                    </span>
                  } @else {
                    <span class="definition-file is-empty">Nessun file importato</span>
                  }
                </div>

                <div class="definition-action">
                  @if (element.filename == null) {
                    <label class="editor-save files-upload" [attr.for]="'fileUpload-' + element.id">
                      <i class="bi bi-upload" aria-hidden="true"></i>
                      Importa Excel
                      <input
                        type="file"
                        [id]="'fileUpload-' + element.id"
                        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        (change)="uploadFiles($event, element.name, element.id)">
                    </label>
                  } @else {
                    <span class="status-badge">Importato</span>
                  }
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <p class="editor-hint">Caricamento elenco…</p>
      }
    </section>
  </div>
</div>
